import { TEntityUntagged } from '@obvious.tech/constellation/Entity'
import { TEntityOverride } from 'src/types'

const override: TEntityOverride<TEntityUntagged<'AnalyticsResultMedia'>> = {
  global: {
    properties: {
      groups: {
        type: 'groups',
      },
      id: {
        displayedName: 'ID',
      },
    },
  },
}

export default override
